exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".deckpage__container{height:100%;width:100%;padding:0;cursor:pointer;background-color:#000}.deckpage__container img{height:100%;width:100%;object-fit:contain}", ""]);

